import { Observable } from "rxjs";

export interface IGroupOrderInviteService {
  /** ermittelt, ob der benutzet bereits ein mitglied dieser oder einer anderen gruppe ist */
  isAlwasyMemberOfGroup(group_code: string): Promise<GroupMember>;
  /** ermittelt informationen zum Gruppencode */
  getGroupCodeInfo(group_code: string): Promise<IGroupCodeInfo>;
  /** versucht dem Gruppencode beizutretten */
  joinGroup(nickname: string, location: number, table_no: string, group_name: string, group_code: string): Promise<JoinGroupResult>;
}

/** mitglieds status zur gruppe */
export enum GroupMember {
  /** ist kein mitglied einer gruppe */
  Not,
  /** ist bereits mitglied der gruppe */
  Yes,
  /** ist mitglied einer anderen gruppe */
  OtherGroup
}

/** informationen zum angeforderten gruppencode */
export interface IGroupCodeInfo {
  /** group name and creator name */
  readonly groupInfo: IGroupInfo;
  /** group is valid */
  readonly valide: boolean;
  /** gruppe ist voll, kein platz frei */
  readonly isFull: boolean;
  /** standort */
  readonly location: number;
  /** tisch nummer */
  readonly tableNo: string;

}

export interface IGroupInfo {
  /** group name */
  readonly groupName: string;
  /** group vreator name */
  readonly groupCreator: string;
}

/** join result */
export enum JoinGroupResult {
  /** User ist bereits einer Gruppe zugeordnet */
  UserIsInGroup,
  /** User an Platz zu setzen war erfolgreich */
  Okay,
  /** User an Platz zu setzen war nicht möglich */
  Fail,
  /** Username ist falsch, vergeben oder gesterrt */
  WrongUserName,
  /** User konnte Gruppe nicht beitreten, Gruppe hat das Limit erreicht */
  GroupFull
}

export interface IJoinGroupDone {
  /** group name and creator name */
  readonly groupInfo: IGroupInfo;
  /** group is valid */
  readonly valide: boolean;
  /** gruppe ist voll, kein platz frei */
  readonly isFull: boolean;
  /** standort */
  readonly location: Observable<number>;
  /** tisch nummer */
  readonly tableNo: Observable<string>;

}